/* tslint:disable */
/* eslint-disable */
export enum EAccessTypeDto {
  Home = 'HOME',
  Kiosk = 'KIOSK'
}
